"use client";

import type { FC } from "react";

// This component intentionally imports as little as possible. Wouldn't want
// errors popping up in our error handling. Try to catch errors with error
// boundaries, long before this happens!
const ErrorPage: FC<{ error: Error; reset: () => void }> = ({ error }) => {
  console.error(error);

  return (
    <div
      style={{
        color: "#8991AD",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100vh",
        margin: "0 10vw",
      }}
    >
      <p
        style={{
          alignSelf: "center",
          marginBottom: "2rem",
        }}
      >
        A top-level exception has occurred 😱
      </p>
      <p style={{ marginBottom: "2rem" }}>
        We&apos;re sorry, this should never happen! If you&apos;ve seen this
        before, or reloading doesn&apos;t fix it, you can help debug it by
        sending a screenshot to
        <a
          className="cursor-pointer text-slateus-200 active:brightness-90"
          href="https://twitter.com/infinily"
          rel="noreferrer"
          target="_blank"
          style={{
            color: "#B5BDDB",
            marginLeft: "0.5rem",
            textDecorationLine: "underline",
          }}
        >
          our X account
        </a>
        .
      </p>
      <p>error name: {error?.name ?? "undefined"}</p>
      <p>error message: {error?.message ?? "undefined"}</p>
      <p>stack trace (partial is fine):</p>
      <p
        style={{
          fontSize: "9px",
          whiteSpace: "pre",
          overflow: "scroll",
          maxWidth: "100%",
        }}
      >
        {error?.stack}
      </p>
    </div>
  );
};

export default ErrorPage;
